// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/FranchisorChannels_TemplatesResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * FranchisorChannels_TemplatesResponse — GET /franchisor-channels/templates.
 * Also reused, with a single-element `rows`, as the response of
 * POST /franchisor-channels/template-save.
 */
import type { FranchisorChannels_TemplateRow } from './FranchisorChannels_TemplateRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface FranchisorChannels_TemplatesResponseDados {
rows: FranchisorChannels_TemplateRow[]
languages: string[]
}

export type FranchisorChannels_TemplatesResponse = ApiResponse<FranchisorChannels_TemplatesResponseDados>;

registerResponseContract('FranchisorChannels_TemplatesResponse', {
  rows: {
    type: 'array',
    required: true,
    items: {
      id:           { type: 'number',  required: true },
      channel_type: { type: 'string',  required: false },
      trigger_key:  { type: 'string',  required: false },
      language:     { type: 'string',  required: false },
      subject:      { type: 'string',  required: false },
      body:         { type: 'string',  required: false },
      updated_by:   { type: 'string',  required: false },
      created_at:   { type: 'string',  required: false },
      updated_at:   { type: 'string',  required: false },
    },
  },
  languages: { type: 'array',   required: true },
})
